export default __webpack_public_path__ + "static/media/CloseIconSvg.eec52c0e.svg";